import { Collection } from 'modules/core/lib/mobx-rest'

import CareerSection from 'modules/company_page/store/models/CareerSection'

class CareerSections extends Collection<CareerSection> {
  get cacheKey(): string {
    return 'careerSections'
  }

  model() {
    return CareerSection
  }
}

export { CareerSections }
